module.exports = __webpack_public_path__ + "img/HABAR.7d97d831.png";